import LogoIcon from './LogoIcon'
import LogoStacked from './LogoStacked'
import LogoStandard from './LogoStandard'

const Logo = {
  Stacked: LogoStacked,
  Standard: LogoStandard,
  Icon: LogoIcon
}

export default Logo
